<template>
  <div>
    <div v-if="!loading">
      <form
        id="carForm"
        ref="carForm"
        class=""
        autocomplete="off"
        @submit.prevent="onSubmitCarForm"
      >
        <div class="form-block mt-2">
          <h2>Vehicle Details</h2>
          <!-- <div class="sale-elsewhere">
          <fieldset class="form-group">
            <label
              for="listed_elsewhere"
            >Is this car for sale elsewhere?</label>
            <div class="custom-radio-container">
              <div class="form-check">
                <input
                  id="listed-yes"
                  class="form-check-input"
                  type="radio"
                  value="true"
                  required
                  :checked="isSaleElsewhere"
                  :name="fields.saleElsewhere"
                  @input="onChangeSaleElsewhere"
                  :disabled="isDisabled"
                >
                <label
                  class="form-check-label"
                  for="listed-yes"
                >Yes</label>
              </div>
              <div class="form-check">
                <input
                  id="listed-no"
                  class="form-check-input"
                  type="radio"
                  value="false"
                  required
                  :checked="!isSaleElsewhere"
                  :name="fields.saleElsewhere"
                  @input="onChangeSaleElsewhere"
                  :disabled="isDisabled"
                >
                <label
                  class="form-check-label"
                  for="listed-no"
                >No</label>
              </div>
            </div>
          </fieldset>

          <template v-if="isSaleElsewhere">
            <p class="note text-danger pb-4">
              For us to consider your car to list on our platform, all other listings must be taken down
            </p>
          </template>
        </div> -->

          <div v-show="!isSaleElsewhere">
            <fieldset class="form-group">
              <label for="year">Year</label>
              <select
                class="form-control"
                :name="fields.year"
                v-model="formData[fields.year]"
                required
              >
                <option
                  v-for="option in selectOptionsMap[fields.year]"
                  :key="option"
                  :value="option"
                  >{{ option }}</option
                >
              </select>
            </fieldset>
            <div class="d-flex">
              <fieldset class="form-group">
                <label for="make">Title</label>
                <input
                  id="make"
                  class="form-control"
                  type="text"
                  title="Please type more than 2 characters."
                  required
                  v-model="formData[fields.title]"
                  :name="fields.title"
                />
              </fieldset>
              <fieldset class="form-group">
                <label for="make">Make</label>
                <input
                  id="make"
                  class="form-control"
                  type="text"
                  title="Please type more than 2 characters."
                  pattern=".{2,}"
                  required
                  v-model="formData[fields.make]"
                  :name="fields.make"
                />
              </fieldset>
            </div>
            <div class="d-flex">
              <fieldset class="form-group">
                <label for="model">Model</label>
                <input
                  id="model"
                  class="form-control"
                  type="text"
                  title="Please type more than 2 characters."
                  pattern=".{2,}"
                  required
                  v-model="formData[fields.model]"
                  :name="fields.model"
                />
              </fieldset>
              <fieldset class="form-group">
                <label for="vin">VIN</label>
                <input
                  id="vin"
                  class="form-control"
                  type="text"
                  pattern="[A-Z\d]{17,17}"
                  title="Please type valid VIN code. Vin code is contain 17 digits and symbols in upper case"
                  v-model="formData[fields.vin]"
                  :name="fields.vin"
                />
                <p v-if="isVinError" class="text-danger">
                  {{ carFormErrorDescription }}
                </p>
              </fieldset>
            </div>
            <div class="d-flex">
              <fieldset class="form-group">
                <label for="mileage">Mileage (mi)</label
                ><input
                  id="mileage"
                  v-model="formData.mileage"
                  v-mask="'#######'"
                  type="number"
                  class="form-control"
                  pattern="[\d]+"
                  title="Please type valid mileage."
                  required
                  :name="fields.mileage"
                />
              </fieldset>
              <fieldset class="form-group">
                <label for="body_style">Body style</label>
                <select
                  id="body_style"
                  class="form-control w-100"
                  :name="fields.bodyStyle"
                  v-model="formData[fields.bodyStyle]"
                  required
                >
                  <option
                    v-for="option in selectOptionsMap[fields.bodyStyle]"
                    :key="option"
                    :value="option"
                    >{{ option }}</option
                  >
                </select>
              </fieldset>

              <!-- <fieldset class="form-group">
              <label for="transmission">Transmission</label>
              <select
                id="transmission"
                class="form-control w-100"
                :name="fields.transmission"
                v-model="formData[fields.transmission]"
                required
                :disabled="isDisabled"
              >
                <option
                  v-for="option in selectOptionsMap[fields.transmission]"
                  :key="option"
                  :value="option"
                >{{ option }}</option>
              </select>
            </fieldset> -->
              <!-- <fieldset class="form-group">
              <label for="engine">Engine</label>
              <select
                id="engine"
                class="form-control w-100"
                :name="fields.engine"
                v-model="formData[fields.engine]"
                required
                :disabled="isDisabled"
              >
                <option
                  v-for="option in selectOptionsMap[fields.engine]"
                  :key="option"
                  :value="option"
                >{{ option }}</option>
              </select>
            </fieldset> -->
            </div>
            <div class="d-flex">
              <fieldset class="form-group">
                <label for="exteriorColor">Exterior Color</label>
                <input
                  id="exteriorColor"
                  class="form-control"
                  type="text"
                  required
                  v-model="formData[fields.exteriorColor]"
                  :name="fields.exteriorColor"
                />
              </fieldset>
              <fieldset class="form-group">
                <label for="interiorColor">Interior Color</label
                ><input
                  id="interiorColor"
                  type="text"
                  class="form-control"
                  required
                  v-model="formData[fields.interiorColor]"
                  :name="fields.interiorColor"
                />
              </fieldset>
            </div>
            <div class="d-flex">
              <fieldset class="form-group">
                <label for="drivetrain">Drive Train</label>
                <select
                  id="drivetrain"
                  class="form-control w-100"
                  :name="fields.drivetrain"
                  v-model="formData[fields.drivetrain]"
                  required
                >
                  <option
                    v-for="option in selectOptionsMap[fields.drivetrain]"
                    :key="option"
                    :value="option"
                    >{{ option }}</option
                  >
                </select>
              </fieldset>
              <fieldset class="form-group">
                <label for="modelSpecificTrim">Model Specific Trim</label
                ><input
                  type="text"
                  class="form-control"
                  id="modelSpecificTrim"
                  v-model="formData[fields.modelSpecificTrim]"
                  :name="fields.modelSpecificTrim"
                />
              </fieldset>
            </div>
            <div class="d-flex">
              <fieldset class="form-group">
                <label for="modelSpecificTrim">City</label
                ><input
                  type="text"
                  class="form-control"
                  id="city"
                  name="city"
                  v-model="formData.city"
                />
              </fieldset>
              <fieldset class="form-group">
                <label for="modelSpecificTrim">State</label
                ><input
                  type="text"
                  class="form-control"
                  id="state"
                  v-model="formData.state"
                  name="state"
                />
              </fieldset>
            </div>
            <div class="d-flex">
              <fieldset class="form-group">
                <label for="modelSpecificTrim">Address</label
                ><input
                  type="text"
                  class="form-control"
                  id="state"
                  v-model="formData.address"
                  name="address"
                />
              </fieldset>
              <fieldset class="form-group">
                <label for="modelSpecificTrim">Price ($)</label
                ><input
                  type="text"
                  class="form-control"
                  id="modelSpecificTrim"
                  v-model="formData.price"
                  :name="fields.price"
                />
              </fieldset>
             
            </div>
            <fieldset class="form-group">
                <label for="modelSpecificTrim">Description</label
                >
                <textarea
                  id="description"
                  class="form-control h-auto"
                  required
                  v-model="formData.description"
                  name="description"
                  rows="6"
                />
              </fieldset>
            <!-- <fieldset class="form-group">
            <label for="country">Where is the car located?</label>
            
          </fieldset> -->

            <!-- <fieldset
            v-if="isLocatedUS"
            class="form-group"
          >
            <label for="zip_code">Zip code</label>
            <input
              id="zip_code"
              v-model="formData.zipCode"
              v-mask="'#####'"
              class="form-control"
              type="number"
              pattern="\d{5,5}"
              title="Please type valid zip code. Valid zip code is contain 5 numbers."
              required
              :name="fields.zipCode"
              :disabled="isDisabled"
            >
            <p
              v-if="isLocationZipCodeError"
              class="text-danger"
            >
              {{ carFormErrorDescription }}
            </p>
          </fieldset> -->

            <!-- <fieldset
            v-if="isLocatedCA"
            class="form-group"
          >
            <label for="city_and_province">City</label>
            <input
              id="city_and_province"
              class="form-control"
              type="text"
              pattern=".*"
              placeholder="City"
              title="Please type city and province. E.g 'Toronto'"
              required
              :value="carData[fields.cityAndProvince]"
              :name="fields.cityAndProvince"
              :disabled="isDisabled"
            >
            <p
              v-if="isLocationCityError"
              class="text-danger"
            >
              {{ carFormErrorDescription }}
            </p>
          </fieldset> -->

            <!-- <fieldset class="form-group textarea">
            <label for="highlights">Tell Us About Your EV</label><textarea
              id="highlights"
              class="form-control"
              required
              v-model="formData[fields.highlights]"
              :name="fields.highlights"
              :disabled="isDisabled"
            />
          </fieldset> -->

            <!-- <fieldset class="form-group textarea">
            <label for="recentServiceHistory">Do the windshield, windows or mirrors have any chips, cracks or heavy scratches?</label><textarea
              id="recentServiceHistory"
              class="form-control"
              required
              v-model="formData[fields.recentServiceHistory]"
              :name="fields.recentServiceHistory"
              :disabled="isDisabled"
            />
          </fieldset> -->

            <!-- <fieldset class="form-group textarea">
            <label for="equipment">Is there any damage or cosmetic flaws to the body/paint or interior?</label>
            <textarea
              id="equipment"
              class="form-control"
              required
              v-model="formData[fields.equipment]"
              :name="fields.equipment"
              :disabled="isDisabled"
            />
          </fieldset> -->

            <!-- <fieldset class="form-group textarea">
            <label for="sellerNotes">What is the condition of your tires (mismatch, flat, worn)? Are there any issues with the wheels (curb rash or damage)?</label><textarea
              id="sellerNotes"
              class="form-control"
              v-model="formData[fields.sellerNotes]"
              :name="fields.sellerNotes"
              :disabled="isDisabled"
            />
          </fieldset> -->
          </div>
        </div>
        <div class="form-block">
          <div
            class="position-relative preview-wrapper"
            style="height: 100%; width: 100%;"
          >
            <div class="row">
              <div
                class="col-xs-6 col-sm-6 col-md-4 col-lg-3 mb-4"
                v-for="photo in formData.images"
                :key="'image-' + `${photo.id}`"
              >
                <div class="container-image position-relative">
                  <VPhotoPreview
                    :image="photo.url"
                    :loading="photo.loading || false"
                    :type="photo.type || 'url'"
                    :mainImage="photo.mainImage === 1 ? true : false"
                  />
                  <button
                    v-if="!photo.loading"
                    type="button"
                    class="btn remove photo-input__remove-btn sss"
                    :class="{
                      'photo-input__remove-btn_deleting': photo.deleting
                    }"
                    aria-label="Delete"
                    @click="removePhoto(photo)"
                  >
                    <span class="sr-only">Delete</span>
                  </button>
                  <!-- <div class="image-checkbox-container">
                    <CInputCheckbox
                      class="car-manager__row-checkbox"
                      size="lg"
                      :name="'checkbox-name' + photo.id"
                      custom
                      :key="`${photo.id}`"
                      :id="`${photo.id}`"
                      :checked="
                        photo &&
                        photo.result &&
                        photo.result.mainImage &&
                        (photo.result.mainImage === 1 ||
                          photo.result.mainImage === true)
                          ? true
                          : false
                      "
                      @change="onChangeCheckBoxInput"
                    />
                  </div> -->
                </div>
              </div>
              <div class="upload-button-container mb-4">
                <div
                  class="upload-button-wrapper btn btn-outline-dark btn-lg cursor-pointer"
                >
                  <div
                    class="handler"
                    tabindex="0"
                    @click="$refs.fileInput.click()"
                  >
                    <input
                      ref="fileInput"
                      accept="image/png,image/jpeg,image/jpg"
                      type="file"
                      autocomplete="off"
                      tabindex="-1"
                      style="display: none"
                      multiple
                      name="csvUpload"
                      @input="fileInputFun"
                    />
                    <span>+</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="form-block">
          <h2>Title Info</h2>
          <fieldset class="form-group">
            <label for="title_country">Where is the vehicle titled?</label><small>Note: We require a US title or Canadian registration for the
                vehicle to be considered.</small>
           
          </fieldset>

          <fieldset
            v-if="isTitledUS"
            class="form-group "
          >
            <label for="title_state">State</label>
            <select
              class="form-control"
              :name="fields.titleState"
              v-model="formData[fields.titleState]"
              required
              :disabled="isDisabled"
            >
              <option
                v-for="option in selectOptionsMap[fields.titleState]"
                :key="option"
                :value="option"
              >{{ option }}</option>
            </select>
          </fieldset>

          <fieldset
            v-if="isTitledCA"
            class="form-group "
          >
            <label for="title_province">Province</label>
            <input
              id="title_province"
              class="form-control"
              type="text"
              required
              v-model="formData[fields.titleProvince]"
              :name="fields.titleProvince"
              :disabled="isDisabled"
            >
          </fieldset>

          <fieldset class="form-group">
            <label for="owner_has_title">Is the vehicle titled in your name?</label>
            <div class="custom-radio-container">
              <div class="form-check">
                <input
                  id="title-yes"
                  class="form-check-input"
                  type="radio"
                  value="true"
                  :checked="!isNotTitledOnSeller"
                  :name="fields.ownerHasTitle"
                  required
                  @input="onChangeTitledOnSeller"
                  :disabled="isDisabled"
                ><label
                  class="form-check-label"
                  for="title-yes"
                >Yes</label>
              </div>
              <div class="form-check">
                <input
                  id="title-no"
                  class="form-check-input"
                  type="radio"
                  value="false"
                  :checked="isNotTitledOnSeller"
                  :name="fields.ownerHasTitle"
                  required
                  @input="onChangeTitledOnSeller"
                  :disabled="isDisabled"
                ><label
                  class="form-check-label"
                  for="title-no"
                >No</label>
              </div>
            </div>
          </fieldset>

          <fieldset
            v-if="isNotTitledOnSeller"
            class="form-group "
          >
            <label for="title_owner">Who’s name is on the title?</label>
            <input
              id="title_owner"
              class="form-control"
              type="text"
              v-model="formData[fields.titleOwner]"
              :name="fields.titleOwner"
              required
              :disabled="isDisabled"
            >
          </fieldset>

          <fieldset class="form-group">
            <label for="title_status">What is the title’s status?</label>
            <select
              class="form-control"
              :name="fields.titleStatus"
              v-model="formData[fields.titleStatus]"
              required
              :disabled="isDisabled"
            >
              <option
                v-for="option in selectOptionsMap[fields.titleStatus]"
                :key="option"
                :value="option.toLowerCase()"
              >{{ option }}</option>
            </select>
          </fieldset>
        </div> -->
        <button
          type="submit"
          class="btn btn-primary btn-lg submit d-block ml-auto mr-auto"
          :class="{ disabled: sendingCar || isSaleElsewhere }"
          :disabled="sendingCar || isSaleElsewhere || isDisabled"
        >
          <CSpinner v-if="sendingCar" size="3xl" color="white" class="mr-3" />
          <span>{{ sendingCar ? "Saving..." : "Save" }} </span>
        </button>
        <!-- <CLink class="car-form__to-top-link" v-if="collapse" @click.prevent="toTop">To top</CLink> -->
      </form>
    </div>
    <div v-if="isCropModalOpen">
      <ImageCropModal
        :imageSrc="imageSrc"
        :closeCurrentModal="closeCurrentModal"
        :uploadFiles="uploadFiles"
        :imageName="imageName"
      />
    </div>
    <div v-if="loading">
      <LoaderComponent />
    </div>
  </div>
</template>
<script>
import {
  createCarManagerMixin,
  carManagerStore
} from "@/mixins/carManagerMixin";

import * as inputErrorHandler from "@/utils/validation/inputErrorHandler";
import {
  carFormFields,
  carFormFieldValues,
  MIN_PHOTO_COUNT,
  yearOptions,
  bodyStyleOptions,
  engineOptions,
  transmissionOptions,
  drivetrainOptions,
  stateOptions,
  titleStatusOptions
} from "@/utils/dictionaries/carForm";
// import VIllustrationImage from './VIllustrationImage'
import ImageTypes from "@/utils/dictionaries/imageTypes";
import LoaderComponent from "@/components/LoaderComponent.vue";
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from "@/mixins/auctionsManagerMixin";
// import VPdfInput from './VPdfInput'
import {
  createMarketplaceMixin,
  marketplaceStore
} from "@/mixins/marketplaceMixin";
import VPhotoPreview from "./VPhotoPreview.vue";
import ImageCropModal from "@/components/ImageCropModal.vue";
import { checkImageOrFail } from "@/utils/validation/image";
import ModalType from "@/utils/dictionaries/modalType";
export default {
  name: "TheMarketplaceForm",

  props: {
    car: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    // VPhotoInput,
    // VIllustrationImage,
    // VPdfInput,
    ImageCropModal,
    VPhotoPreview,
    LoaderComponent
  },

  mixins: [
    createAuctionManagerMixin(),
    createCarManagerMixin(),
    createMarketplaceMixin()
  ],

  data: () => ({
    imageSrc: null,
    imageName: null,
    isCropModalOpen: false,
    errorType: null,
    errorMessage: null,
    currentRouteName: null,
    loading: true,
    imageIds: [],
    collapse: true,
    isDealer: false,
    isSaleElsewhere: false,
    isLocatedUS: true,
    isLocatedCA: false,
    isTitledUS: true,
    isTitledCA: false,
    isModifiedStock: false,
    isNotTitledOnSeller: false,
    isReservePrice: false,
    isSoldAfterAuction: false,
    otherItemsIncludedInSale: 0,
    videos: 0,
    fields: { ...carFormFields, price: "price" },
    minPhotoCount: MIN_PHOTO_COUNT,
    carFormError: null,
    exteriorPhotosErrorMsg: `Upload at least ${MIN_PHOTO_COUNT} photos of the vehicle’s exterior`,
    interiorPhotosErrorMsg: `Upload at least 6 photos of the vehicle’s interior`,

    sendingCar: false,
    pdfInputValue: null,
    formData: {
      sellerPhone: "",
      mileage: "",
      price: "",
      zipCode: "",
      city: "",
      state: "",
      address: "",
    }
  }),

  computed: {
    isAfterAuctionError() {
      return inputErrorHandler.isAfterAuctionError(this.carFormError);
    },
    isLocationZipCodeError() {
      return inputErrorHandler.isLocationZipCodeError(this.carFormError);
    },
    isLocationCityError() {
      return inputErrorHandler.isLocationCityError(this.carFormError);
    },
    isVinError() {
      return inputErrorHandler.isVINError(this.carFormError);
    },
    carFormErrorDescription() {
      return inputErrorHandler.getErrorDescription(this.carFormError);
    },
    carImages() {
      return this[carManagerStore.getterTypes.GETTER_CAR];
    },
    carData() {
      return this[marketplaceStore.getterTypes.GETTER_SELECTED_DATA];
    },
    selectOptionsMap() {
      return {
        [carFormFields.year]: yearOptions,
        [carFormFields.bodyStyle]: bodyStyleOptions,
        [carFormFields.engine]: engineOptions,
        [carFormFields.transmission]: transmissionOptions,
        [carFormFields.drivetrain]: drivetrainOptions,
        [carFormFields.titleState]: stateOptions,
        [carFormFields.titleStatus]: titleStatusOptions
      };
    },
    exteriorPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Exterior
      );
    },
    interiorPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Interior
      );
    },
    mechanicalPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Mechanical
      );
    },
    docsPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Docs
      );
    },
    otherPhotos() {
      if (!this.carData.carImages) return;
      return this.carData.carImages.filter(
        image => image.type === ImageTypes.Other
      );
    },
    carDataVideos() {
      const result = [];
      for (let index = 0; index < this.videos; index++) {
        result.push(
          this.carData?.carVideos[index]
            ? this.carData?.carVideos[index]
            : { url: "" }
        );
      }

      return result;
    },
    isDisabled() {
      return this.carData.disabled;
    }
  },

  watch: {
    pdfInputValue(newValue) {
      this.updateFieldsHistoryReport(newValue);
    },
    isAfterAuctionError(v) {
      if (v) {
        this.focusToInputByName(carFormFields.soldAfterAuctionValue);
      }
    },
    isLocationZipCodeError(v) {
      if (v) {
        this.focusToInputByName(carFormFields.zipCode);
      }
    },
    isLocationCityError(v) {
      if (v) {
        this.focusToInputByName(carFormFields.cityAndProvince);
      }
    },
    isVinError(v) {
      if (v) {
        this.focusToInputByName(carFormFields.vin);
      }
    }
  },
  mounted() {
    this.currentRouteName = this.$route.name;
  },
  created() {
    this.getDateById();
  },

  methods: {
    async removePhoto(photo) {
      const deleting = async () => {
        photo.deleting = true

        try {
          await this[auctionManagerStore.actionTypes.ACTION_REMOVE_CAR_PHOTO]({ imageId: photo.id })
        } catch (error) {}

        photo.deleting = false
        this.removeItemFromArray(this.formData.images, photo, true)

        this.$modals.close(ModalType.ConfirmationModal)
      }

      this.$modals.open(ModalType.ConfirmationModal, {
        title: 'Deletion',
        body: 'Are you sure you want to delete the photo? It will be deleted without saving.',
        buttonText: 'Delete',
        onClickButton: deleting
      })
    },
    removeItemFromArray(array, item, isPhoto) {
      const itemIndex = isPhoto ?
        array.findIndex(_item => _item.id === item.id) :
        array.indexOf(item)

      if (itemIndex >= 0) {
        array.splice(itemIndex, 1)
      }
    },
    closeCurrentModal(){
      this.isCropModalOpen = false;
    },
    onInputFiles(e) {
      const file = e.target.files[0];
      this.imageName = file.name;
      if (file) {
        // Read the selected image file and set it as the cropper source
        const reader = new FileReader();
        reader.onload = () => {
          debugger
          this.imageSrc = reader.result;
          this.isCropModalOpen = true;
        };
        reader.readAsDataURL(file);
      }
      // this.uploadFiles(e.target.files);
    },
    fileInputFun(e){
      this.onInputFiles(e)
      this.$refs.fileInput.value = null;
    },
    async uploadFiles(files) {
      this.isCropModalOpen = false
      this.imageName = null

      for (let idx = 0; idx < Array.from(files).length; idx++) {
        try {
          checkImageOrFail(files[idx]);
          const newPhoto = {
            id: this.formData.images.length + 1,
            url: files[idx],
            loading: true,
            deleting: false,
            result: null,
            type: 'file'
          };
          this.formData.images.push(newPhoto);
          debugger
          console.log("this.formData.images",this.formData.images)

          this[marketplaceStore.actionTypes.UPLOAD_IMAGE]({
            idx: newPhoto.id,
            file: files[idx],
            name: this.imageName,
            carId: this.formData.id,
          })
            .then(({ arrId,uploadImageId, data }) => {
              debugger
              const index = this.formData.images.findIndex(f => f.id === arrId);
              // eslint-disable-next-line vue/no-mutating-props

              this.formData.images.splice(index, 1, {
                ...this.formData.images[index],
                result: data,
                // file: files[idx],
                type: 'file',
                loading: false
              });

            })
            .catch((err) => {
              console.log("err", err)
              debugger
              const index = this.formData.images.findIndex(f => f.id === this.id);
              if(index > -1){
                this.formData.images.splice(index, 1)
              }
            });
        } catch (error) {
          this.pushError(error.message);
        }
      }

      this.$emit("input", files);
    },
    async getDateById() {
      try {
        this.loading = true;
        await this[marketplaceStore.actionTypes.GET_DATA_BY_ID]({
          id: this.car.id
        });
        this.setInitialData();
        this.loading = false;
      } catch (errorMessage) {
        this.loading = false;
        console.log(errorMessage);
      }
    },
    reloadRoute() {
      // Get the current route
      const currentRoute = this.$route;

      try {
        // Use $router.push to navigate to the same route
        this.$router
          .push({
            path: currentRoute.path,
            params: currentRoute.params,
            query: currentRoute.query
          })
          .catch(() => {});
      } catch (error) {
        // Handle the NavigationDuplicated error (optional)
        console.warn("NavigationDuplicated error caught:", error.message);
      }
    },
    toTop() {
      const modal = document.querySelector(`[role="dialog"].modal`);
      if (modal) {
        modal.scrollTop = 0;
      }
    },

    updateFieldsHistoryReport(value) {
      this.fields.historyReport = value;
    },
    getCarVideoUrl(index) {
      return this.carDataVideos;
    },

    setInitialData() {
      let images = [];
      this.formData = {
        mileage: this.carData[carFormFields.mileage],
        zipCode: this.carData[carFormFields.location]?.zipCode,
        ...this.carData
      };
      console.log("this.formData", this.formData);
    },

    focusToInputByName(name) {
      const input =
        this.$refs.carForm &&
        this.$refs.carForm.querySelector(`input[name="${name}"]`);
      input && input.focus();
    },

    checkPhotoInputComponentValidity(number) {
      const component = this.$refs[`photoInput${number}`];
      return component && component.hasErrors();
    },

    checkPhotoInputComponentReady(number) {
      const component = this.$refs[`photoInput${number}`];
      return component && component.hasLoadingPhotos();
    },

    async onSubmitCarForm() {
      // if (!this.$refs.carForm.checkValidity()) return
      this.sendCarForm();
    },

    async sendCarForm() {
      this.carFormError = null;
      this.sendingCar = true;

      try {
        await this[marketplaceStore.actionTypes.ACTION_UPDATE_MARKETPLACE_CAR]({
          carId: this.car.id,
          formData: this.getCarFormData()
        });
        this.$emit("success");
      } catch (error) {
        this.carFormError = error.response && error.response.data;
      } finally {
        setTimeout(() => {
          this.sendingCar = false;
        }, 500);
      }
    },

    onChangeSellerType() {
      this.isDealer = this.getCarFormData().get("sellerType") === "Dealer";
    },

    onChangeSaleElsewhere() {
      this.isSaleElsewhere =
        this.getCarFormData().get("saleElsewhere") === "true";

      if (this.isSaleElsewhere) {
        this.otherItemsIncludedInSale = 0;
      }
    },

    onChangeCountry() {
      this.isLocatedCA = this.getCarFormData().get("country") === "CA";
      this.isLocatedUS = this.getCarFormData().get("country") === "US";
    },

    onChangeTitleLocation() {
      this.isTitledCA = this.getCarFormData().get("titleCountry") === "CA";
      this.isTitledUS = this.getCarFormData().get("titleCountry") === "US";
    },

    onChangeTitledOnSeller() {
      this.isNotTitledOnSeller =
        this.getCarFormData().get("ownerHasTitle") === "false";
    },

    onChangeStock() {
      this.isModifiedStock =
        this.getCarFormData().get("vehicleStock") === "modified";
    },

    onChangeIsReservePrice() {
      this.isReservePrice = this.getCarFormData().get("reserve") === "true";
    },

    onChangeIsSoldAfterAuction() {
      this.isSoldAfterAuction =
        this.getCarFormData().get("isSoldAfterAuction") === "true";
    },

    onInputPhotos() {
      console.log(this.$refs.photoInput);
    },
    onUpdateMainImage(imgObj) {
      this.uploadedImages.forEach(image => {
        if (image.id === imgObj.result.id) {
          image.mainImage = imgObj.result.mainImage;
        } else {
          image.mainImage = 0;
        }
      });
      this.$forceUpdate();
      this.reloadRoute();
    },

    /**
     * @returns {FormData} formData
     */
    getCarFormData() {
      const formData = new FormData(this.$refs.carForm);
      debugger;
      formData.append("historyReport", this.pdfInputValue);

      return formData;
    },

    addOtherItemsIncludedInSale() {
      this.otherItemsIncludedInSale += 1;
    },

    addVideos() {
      this.videos += 1;
    }
  }
};
</script>
<style>
.container-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  border-radius: 15px;
  border: 1px solid #ddd !important;
  height: 140px;
  background: #fff;
}
.container-image .temp-img.preload-wrap {
  position: relative;
  height: 100%;
  width: 100%;
}
.upload-button-container {
  height: 140px;
  border-radius: 16px;
  border: 1px solid #000;
  width: 150px;
}
.upload-button-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 16px;
}
.upload-button-wrapper .handler {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 100px;
}
</style>
